<script>
  import { createEventDispatcher } from "svelte";
  const dispatch = createEventDispatcher();

  function buyTicketNumber(num) {
    dispatch("ticketNumber", {
      num: ticket.user ? null : num,
    });
  }

  export let ticket, mine;
</script>

{#if ticket}
  <div
    class={`ticket ${ticket.user ? "used" : "not-used"}`}
    class:mine
    on:click={() => buyTicketNumber(ticket.number)}
  >
    <p>{ticket.number}</p>
  </div>
{/if}

<style>
  .ticket > p {
    font-weight: bold;
    font-size: 1.15rem;
  }
  .ticket {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    color: inherit;
  }
  .used {
    color: #c5c5c5;
    background: var(--pink);
    cursor: default;
  }
  .used.mine {
    background: var(--neutral);
  }
  .not-used {
    background: var(--green);
    cursor: pointer;
  }
  .not-used:hover {
    color: var(--blue);
    box-shadow: 0px 8px 15px -5px rgb(0 0 0 / 20%);
    transition: linear 0.1s;
  }
</style>
